module.exports = __webpack_public_path__ + "static/media/bridge.63ef7096.svg";